import { memo } from 'react';
import { Modal, Space, Row, Col, Button, Divider } from 'antd';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'translations';
import { LINKS } from 'configuration';
import LogoCircle from 'assets/ui-wappsto-style/images/wappsto-logo/200w/wappsto-logo-circle.png';
import SignInOptions from './SignInOptions';
import LoginForm from './LoginForm';

interface AuthenticationModalProps {
  hide: (...args: any[]) => any;
  isVisible: boolean;
  isClosable?: boolean;
}

const AuthenticationModal = memo(({ hide, isVisible, isClosable }: AuthenticationModalProps) => {
  const { tC } = useTranslation('features', 'authentication');
  const isSmallScreen = window.innerWidth < 992;

  return (
    <Modal
      open={isVisible}
      onCancel={hide}
      closable={isClosable}
      title={
        <Space size="large">
          <img alt="Wappsto Logo" width={50} src={LogoCircle} />
          {tC('signInToWappstoTitle')}
        </Space>
      }
      className="modal medium"
      footer={null}
      destroyOnHidden>
      <Row gutter={[16, 16]}>
        <Col
          style={{ textAlign: 'center' }}
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 12 }}
          xl={{ span: 12 }}
          xxl={{ span: 12 }}>
          <LoginForm />
          <Button size="large" block type="link">
            <NavLink to={LINKS.registration}>{tC('registerButton')}</NavLink>
          </Button>
        </Col>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 2 }}
          xl={{ span: 2 }}
          xxl={{ span: 2 }}>
          <Divider
            type={isSmallScreen ? 'horizontal' : 'vertical'}
            style={isSmallScreen ? {} : { height: '100%', margin: '0 30px' }}
          />
        </Col>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 10 }}
          xl={{ span: 10 }}
          xxl={{ span: 10 }}
          style={{ textAlign: 'center' }}>
          <SignInOptions />
        </Col>
      </Row>
    </Modal>
  );
});

AuthenticationModal.displayName = 'AuthenticationModal';

export default AuthenticationModal;
